module.exports = __webpack_public_path__ + "img/12_grimmauld_place.de31619a.jpg";